import { FunctionComponent, ReactNode } from "react";
import { Input } from "./ui/input";
import { cn } from "@/lib/utils/ui";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface InputFieldEditButtonProps {
  value: string;
  setValue: (newValue: string) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  trailingIcon?: ReactNode;
  trailingTooltip?: string;
}

const InputFieldEditButton: FunctionComponent<InputFieldEditButtonProps> = ({
  value,
  setValue,
  placeholder,
  className,
  disabled = false,
  trailingIcon,
  trailingTooltip,
}) => {
  return (
    <div className="relative flex w-full max-w-sm items-center space-x-2">
      <Input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className={cn(
          "border-none disabled:opacity-100 disabled:cursor-auto",
          trailingIcon && "pr-10",
          className
        )}
        disabled={disabled}
      />
      {trailingIcon && (
        <div className="absolute right-3 top-1/2 -translate-y-1/2">
          {trailingTooltip ? (
            <Tooltip>
              <TooltipTrigger asChild>
                <span className="inline-flex items-center text-muted-foreground">
                  {trailingIcon}
                </span>
              </TooltipTrigger>
              <TooltipContent>{trailingTooltip}</TooltipContent>
            </Tooltip>
          ) : (
            <span className="inline-flex items-center text-muted-foreground">
              {trailingIcon}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default InputFieldEditButton;
